import React , {useEffect} from "react";
import { GetProfileImages } from "../../DocumentDetails/slice";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

import { DEFAULT_AVATAR_URL, DEFAULT_COVER_URL } from "../../../common/enum";
import { Avatar } from "@mui/material";
import { useDispatch } from "react-redux";

const ProfileAndBanner = ({ entityLeastDetails, address , donationId}) => {
  const replaceImage = (error) => {
    error.target.src = DEFAULT_AVATAR_URL;
  };

  const [entitybanneruri, setentitybanneruri] = React.useState("");
  const [profilepictureuri, setprofilepictureuri] = React.useState("");
  const dispatch = useDispatch();

  useEffect(() => {
  if(entityLeastDetails?.bannerImage != "string" && entityLeastDetails?.bannerImage != null ){
       dispatch(GetProfileImages(entityLeastDetails?.bannerImage))
       .unwrap()
        .then((response) => {
          if(response.isActive != null){
            setentitybanneruri(response.isActive);
          }else{
            setentitybanneruri(DEFAULT_COVER_URL);
          }
        })
    }

    if(entityLeastDetails?.profilePicture != "string" && entityLeastDetails?.profilePicture != null ){
       dispatch(GetProfileImages(entityLeastDetails?.profilePicture))
       .unwrap()
        .then((response) => {
         if(response.isActive != null){
            setprofilepictureuri(response.isActive);
          }else{
            setprofilepictureuri(DEFAULT_AVATAR_URL);
          }
        })
    }
	})
 // console.log(entityLeastDetails);
  return (
    <Box
      sx={{
        height: "110px",
        backgroundImage: `url(${
          entityLeastDetails?.bannerImage === null ||
          entityLeastDetails?.bannerImage === "string"
            ? DEFAULT_COVER_URL
            : entitybanneruri
        }),url(${DEFAULT_COVER_URL})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        position: "relative",
      }}
      
    >
       
      <Box
        sx={{
          // position: "absolute",
          width: "100%",
          height: "110px",
          bgcolor: "rgba(0, 0, 0, 0.54)",
          // display: "flex",
          // justifyContent: "flex-start",
        }}
      >
        <Avatar
          alt="Profile picture"
          src={
            entityLeastDetails === null ||
            entityLeastDetails?.profilePicture === "string" ||
            entityLeastDetails?.profilePicture === null
              ? DEFAULT_AVATAR_URL
              : profilepictureuri
          }
          onError={replaceImage}
          sx={{
            position: "absolute",
            backgroundColor: "green",
            margin: "0 30px",
            left: "0",
            right: "0",
            bottom: "0",
            borderRadius: "50%",
            width: "100px",
            height: "100px",
            transform: "translateY(50%)" /* additional 50% of own height */,
            boxShadow: "0 0 0 10px #fff",
            "& img": {
              height:
                entityLeastDetails === null ||
                entityLeastDetails?.profilePicture === "string" ||
                entityLeastDetails?.profilePicture === null
                  ? "100%"
                  : "100%",
              width:
                entityLeastDetails === null ||
                entityLeastDetails?.profilePicture === "string" ||
                entityLeastDetails?.profilePicture === null
                  ? "100%"
                  : "100%",
            },
          }}
        />
        <Typography
          variant="h6"
          sx={{
            position: "absolute",
            color: "white",
            left: "150px",
            right: "0",
            bottom: "40px",
            fontSize: "1.50rem!important",
          }}
        >
          {entityLeastDetails.isParentEntity !== undefined
            ? entityLeastDetails.isParentEntity
              ? entityLeastDetails?.entityName
              : entityLeastDetails?.entityName
            : entityLeastDetails?.entityName}
        </Typography>
        <Typography
          
          

            sx={{
              position: "absolute",
              color: "white",
              left: "150px",
              right: "0",
              bottom: "15px",
             
              fontFamily: "Poppins",
              fontSize: "1rem!important",
              "@media (max-width:1280px)": {
                overflow: "hidden",
                textOverflow: "ellipsis",
                display: "inline-block",
                width: "90%",
                whiteSpace: "nowrap",
              },
            }}
          >
            {" "}
            
            {donationId && <span title={`Código de doação`}>#{donationId}</span>}
          </Typography>
      </Box>
    </Box>
  );
};

export default ProfileAndBanner;
